import React from 'react';
import { Table } from '../../components';
import { Col, Grid, GridColumnSize, Row } from '../../grid';
import { block } from '../../utils';
import './Table.css';
const b = block('table-block');
export const TableBlock = (props) => {
    const { title, table } = props;
    return (React.createElement("div", { className: b() },
        React.createElement(Grid, { className: b('content') },
            React.createElement(Row, { className: b('row') },
                React.createElement(Col, { sizes: { [GridColumnSize.Md]: 4, [GridColumnSize.All]: 12 } },
                    React.createElement("h2", { className: b('title') }, title)),
                React.createElement(Col, { sizes: { [GridColumnSize.Md]: 8, [GridColumnSize.All]: 12 } },
                    React.createElement(Table, Object.assign({ className: b('table') }, table)))))));
};
export default TableBlock;
